export const TermsAndConditions = () => (
  <div className="terms-conditions tnm-v1">
    <main className="main">
      <section className="page-hero">
        <div className="page-header">
          <div className="container">
            <h1>Terms &amp; Conditions</h1>
          </div>
        </div>
      </section>
      <section className="legal">
        <div className="container">
          <div className="terms">
            <h3>PRICE</h3>
            <ul>
              <li>
                The price of the Food and The Nutritionist MCR delivery charges
                will be as quoted on the Site from time to time.
              </li>
              <li>
                The Nutritionist MCR reserve the right to increase the price of
                the Food to reflect any increase in the cost to us due to any
                factor beyond The Nutritionist MCR control (such as, and without
                limitation, the cost of transporting the Food to your address,
                any foreign exchange fluctuation, increases in the cost of raw
                ingredients, increases in the costs of labour, materials or
                other costs of manufacture).
              </li>
              <li>
                Where additional delivery costs are applicable, these costs will
                be clearly indicated during the order process.
              </li>
            </ul>
            <h3>RETURNS, REPLACEMENTS, REFUNDS</h3>

            <p>
              If you are not satisfied with your order, or something was not as
              expected, please contact us within seven (7) days by email at{' '}
              <a href="mailto:ryan@thenutritionistmcr.com">
                ryan@thenutritionistmcr.com
              </a>
            </p>
            <h3>INTELLECTUAL PROPERTY RIGHTS</h3>

            <p>
              The Nutritionist MCR are the owner or the licensee of all
              intellectual property rights in the Site (including the The
              Nutritionist MCR logo), whether registered or unregistered, and in
              the material published on it.
            </p>
            <h3>HEALTH</h3>
            <ul>
              <li>
                The Nutritionist MCR strongly recommends that you seek medical
                advice before starting any nutritional program. The information
                provided by The Nutritionist MCR is not medical advice nor a
                substitute for medical treatment. Never disregard professional
                medical advice or delay in seeking it because of something you
                have read on the Site or other The Nutritionist MCR
                publications, including social media bulletins. This includes
                any advice The Nutritionist MCR provide to you by email, over
                the telephone or in person.
              </li>
              <li>
                You should not use The Nutritionist MCR if you are severally
                underweight, pregnant, breastfeeding, under 18 or have any
                medical condition which affects your dietary requirements. The
                Nutritionist MCR is not liable for any illness or medical
                reaction caused by contact with or consumption of The
                Nutritionist MCR Food. The Nutritionist MCR may not be able to
                accommodate clients with specialist dietary needs or conditions
                and, in particular, The Nutritionist MCR are unable to deliver
                to those who have allergies that could result in illness,
                anaphylactic shock or those clients with diabetes who are
                insulin dependent.
              </li>
              <li>
                If you have any type of food allergy, The Nutritionist MCR ask
                that you refrain from eating The Nutritionist MCR Food.
              </li>
            </ul>
            <h3>RESULTS</h3>

            <p>
              Results from the purchase of The Nutritionist MCR Food are not
              guaranteed. For the best results Food should be combined with
              daily exercise.
            </p>
            <ul>
              <li>
                will vary from person to person. Results (measured in terms of
                fat loss and lean muscle gain) may vary from person to person
                for several reasons including but not limited to environment,
                genetics, metabolic rate, and physical exertion.
              </li>
            </ul>
            <h3>COMPLAINTS</h3>

            <ul>
              <li>
                If you have a comment, concern or complaint about any Food you
                have purchased from us, please contact us via email at{' '}
                <a href="mailto:ryan@thenutritionistmcr.com">
                  ryan@thenutritionistmcr.com
                </a>
              </li>
            </ul>
            <h3>CANCELLATION AND CONSUMER RIGHTS</h3>
            <ul>
              <li>
                By entering into these Terms you acknowledge that there is no
                automatic right to a refund where you wish to cancel your
                subscription for the Services.
              </li>
              <li>
                If you wish to cancel your subscription all requests must be
                sent by email to{' '}
                <a href="mailto:ryan@thenutritionistmcr.com">
                  ryan@thenutritionistmcr.com
                </a>{' '}
                The Nutritionist MCR require three (3) full working days’ notice
                in order to cancel your delivery in all instances (save for
                except for the three (3) day trial package which cannot be
                cancelled).
              </li>
              <li>
                For all cancellations, the daily price of the package will be
                adjusted to reflect the number of days actually delivered.
              </li>
              <li>
                {' '}
                If you notify us that you wish to cancel at least three full
                working days before your first delivery, The Nutritionist MCR
                will cancel your order and refund a maximum of the full amount
                paid by you.
              </li>
              <li>
                Any refunds will be made within thirty (30) days from the date
                on which your subscription is cancelled.
              </li>
              <li>
                You can re-subscribe at any time, but The Nutritionist MCR
                reserves the right not to permit re-subscription.
              </li>
              <li>
                If you are unhappy with your Food for a legitimate reason such
                as:
              </li>
              <ul>
                <li>missing Food; or</li>
                <li>failure of Food to arrive.</li>
              </ul>
            </ul>
            <p>
              The Nutritionist MCR MAY provide a refund or other compensation as
              appropriate. Any refunds or compensation will be provided at The
              Nutritionist MCR sole discretion.
            </p>
            <h3>WARRANTIES</h3>
            <ul>
              <li>
                The Nutritionist MCR warrant that any Food purchased from us
                will, on delivery; conform with its description, be of
                satisfactory quality, and be reasonably fit for all the purposes
                for which Food of that kind is commonly supplied.
              </li>
              <li>
                You warrant that any and all of the Food ordered by you is for
                your personal use only and not for resale.
              </li>
            </ul>
            <h3>VARIATION</h3>

            <ul>
              <li>
                The Nutritionist MCR have the right to revise and amend these
                Terms from time to time to reflect changes in market conditions
                affecting The Nutritionist MCR business, changes in technology,
                changes in payment methods, changes in relevant laws and
                regulatory requirements and changes in The Nutritionist MCR
                system’s capabilities.
              </li>
            </ul>
          </div>
        </div>
      </section>{' '}
    </main>
  </div>
);
